const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'DIRECTO_CUSTOMERS_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default reducer;
